import React from "react";
import Select from "react-select";

export const RedSelect = (props) => {
  const newProps = { ...props };
  const { onChange, onBlur, name, formik, defiaultValue } = newProps;

  const onChangeOverride = (selected, options) => {
    if (onChange) {
      onChange(selected, options);
    }
    if (name && formik) {
      formik.setFieldValue(name, selected && selected.value);
    }
  };

  const onBlurOverride = (event) => {
    if (onBlur) {
      onBlur(event);
    }
    if (name && formik) {
      formik.setFieldTouched(name);
    }
  };

  newProps.onChange = onChangeOverride;
  newProps.onBlur = onBlurOverride;

  return (
    <Select
      {...newProps}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary50: "#E9EDF2",
        },
      })}
      defaultValue={defiaultValue}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),

        option: (provided, state) => {
          if (state.isSelected || state.isFocused) {
            return {
              ...provided,
              fontFamily: "Nunito",
              fontSize: "12px",
              fontWeight: "300",
              textAlign: "left",
              backgroundColor: "#E9EDF2",
              color: "black",
              ":focus": {
                backgroundColor: "#f8f8f8",
                color: "black",
              },
              ":hover": {
                backgroundColor: "#f8f8f8",
                color: "black",
              },
            };
          }
          return {
            ...provided,
            fontFamily: "Nunito",
            fontSize: "12px",
            fontWeight: "300",
            textAlign: "left",
          };
        },

        control: (provided, state) => {
          const result = {
            ...provided,
            fontFamily: "Nunito",
            fontSize: "12px",
            fontWeight: "300",
            textAlign: "left",
            border: newProps.border || "1px solid red",
            borderBottom: newProps.border || "",
            borderRadius: newProps.borderRadius || "5px",
            ":hover": {
              border: "1px solid red",
              outline: "none",
            },
            ":focus": {
              border: "1px solid red !important",
              outline: "none !important",
            },
          };

          if (state.isSelected || state.isFocused) {
            return {
              ...result,
              border: "none",
              outline: "none",
              boxShadow: "0px 2px 0px 0px rgba(0,0,0,0)",
            };
          }
          return result;
        },

        placeholder: (provided) => ({
          ...provided,
          color: "red",
          ":hover": {
            color: "red",
          },
        }),

        indicatorSeparator: () => ({
          display: "none",
        }),

        dropdownIndicator: (provided) => ({
          ...provided,
          color: "red",
          ":hover": {
            color: "red",
          },
        }),
      }}
    />
  );
};

RedSelect.propTypes = Select.propTypes;
